import { DOCTYPES } from '@/constants/doctypes.ts'
import { PERMISSIONS } from '@/constants/permissions.ts'
import { createDoctypeListDetailRoutes } from '@/routers/routes/createDoctypeRoutes'

const {
  detail: routeSubscriberDetail,
  home: routeSubscribersHome,
  root: routeSubscribersRoot,
} = createDoctypeListDetailRoutes({
  detailName: 'subscriber-detail',
  doctype: DOCTYPES.EMAIL_GROUP_MEMBER,
  extraListDoctypes: { [DOCTYPES.REPORT]: [PERMISSIONS.READ] },
  homeName: 'subscribers',
  path: 'subscribers',
  views: {
    detail: async () => await import('@/components/viewsExternal/subscribers/ViewSubscriber.vue'),
    list: async () => await import('@/components/viewsExternal/newsletter/ViewNewsletter.vue'),
  },
})

export { routeSubscriberDetail, routeSubscribersHome, routeSubscribersRoot }
